export default "__VITE_ASSET__d91de88f__"